import { useState, useEffect } from "react";

const useWindowDimensions = () => {
  const [dimensions, setDimensions] = useState({
    width: window.innerWidth / (window.devicePixelRatio || 1),
    height: window.innerHeight / (window.devicePixelRatio || 1),
  });

  useEffect(() => {
    const handleResize = () => {
      setDimensions({
        width: window.innerWidth / (window.devicePixelRatio || 1),
        height: window.innerHeight / (window.devicePixelRatio || 1),
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return dimensions;
};

export default useWindowDimensions;
